module.exports = __webpack_public_path__ + "assets/481058b7875354c47ef13350f5f5fcce.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/Flower.mp3
 ** module id = 381
 ** module chunks = 0
 **/